const CommonFunctions = {
    getNameAbbreviation: (firstName: string, lastName: string) => {
        let abbr = '';
        if (firstName != null && firstName.length > 0) {
            abbr = firstName.charAt(0);
        }
        if (lastName != null && lastName.length > 0) {
            abbr = abbr + lastName.charAt(0);
        }
        return abbr;
    }
};

export default CommonFunctions;
